/**
 * Hostname helpers shared by the app entrypoint and the OpenReplay tracker.
 *
 * Kept strict on purpose: a substring check like `hostname.includes('localhost')`
 * would treat an attacker-controlled host such as `localhost-evil.com` as local,
 * which would disable secure-mode / dev-only behavior on a real deployment. We
 * only treat a host as local when it is an exact loopback alias or a true
 * `*.localhost` subdomain.
 */
export function isLocalhostHostname(hostname: string): boolean {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname.endsWith('.localhost')
  );
}
